module.exports = __webpack_public_path__ + "img/10m1.ba51247c.jpg";